import { Component,Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SdexAdminService } from '../../services/sdex/sdex-admin.service';

@Component({
    selector: 'app-delete-user',
    templateUrl: './delete-user.component.html',
    styleUrls: ['./delete-user.component.scss'],
    standalone: false
})
export class DeleteUserComponent implements OnInit {
  @Input() userId: any;
  @Input() userData: any;
  @Input() selectedCompanyId: any;
  @Input() parentCompany: any;
  companyId:any;
  errorMessage: any;

  
  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly adminService: SdexAdminService
  ) {}
  ngOnInit(): void {
    const localData: any = localStorage.getItem('selfDetails');
    this.companyId = JSON.parse(localData).company;

  }

  closeDialog() {
    this.activeModal.close();
  }

  deleteUser(){ 
    this.adminService.deleteUser(this.userId).subscribe((res: any) => {
      this.closeDialog();
    });
  }
}
